import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Approach from "@/pages/Approach";
import Contact from "@/pages/Contact";
import Previews from "@/pages/Previews";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/approach" element={<Approach />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/previews" element={<Previews />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
